"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgUpload(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M6 10v4h12v-4h2v5a1 1 0 01-1 1H5a1 1 0 01-1-1v-5zm6-10l4 5h-2v6h-4V5H8z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Upload')(SvgUpload);
//# sourceMappingURL=Upload.js.map